import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';
import { NavigationInPageConfig } from './navigation-in-page.model';
import { addScrollClickTrigger, init as initHashScrolling } from '@project/shared/utils/hashscrolling/js/hashscrolling';
import * as copy from 'copy-to-clipboard';

@createModule('NavigationInPage')

/**
 * @author Guener Sakinc <guener.sakinc@namics.com>
 *
 * 1. Check if there are any AnchorIs and AnchorTitles available to show or remove it
 * 2. Grab properties from required attributes and generate mark up to be rendered
 * 3. Anchor bar container implemented in the existing header to take over the animation properties
 * 4. Handles the visibility/fading of the anchor bar by the target elements' top position and the calculated threshold
 *   incl. its offset
 * 5. Calculate vertical scroll position of the document to hilite the proper anchor item
 * 6. Re-position the anchor bar vertical scrolling position when the viewport is too small for all items to be shown
 * 7. Calculate the width of the status bar under the anchor bar buttons and include a css transition
 * 8. Scroll vertically to content item when an anchor bar item is clicked
 *
 */
export class NavigationInPage extends TerrificSpec {
	/**
	 * @var {NavigationInPageConfig} config - returns the model data
	 */
	config: NavigationInPageConfig;

	/**
	 * @var {?} timer - returns a timer object that is needed to handle the showHideAnchorBar() functionality
	 * and avoid flickering of the anchor bar when scrolling quickly changing scroll directions over the threshold area
	 */
	timer: any = null;

	/**
	 * @var {number} winScrollY - return the current window scroll top value.
	 */
	winScrollY = 0;

	/**
	 * @var listItemPlaceholder {string} - holds the list item mark-up completely given by the pattern
	 *
	 */
	listItemPlaceholder: string;

	/**
	 * hasCanvasOffset
	 *
	 */
	hasCanvasOffset: boolean;
	activeItem: number;
	animationFrameId: number = 0;
	$links: JQuery;
	$ctx: JQuery;
	$shareBtn: JQuery;

	start(resolve: () => void) {
		this.config = {
			mainSelector: '.js-m-navigation-in-page',
			attributeNameTarget: 'data-anchor-id-target',
			attributeNameId: 'data-anchor-id',
			attributeNameTitle: 'data-anchor-title',
			targetSelector: '.js-m-navigation-in-page__list-items',
			buttonSelector: '.js-m-navigation-in-page__item-anchor',
			statusBarWrapperSelector: '.js-m-navigation-in-page__wrapper',
			statusBarSelector: '.js-m-navigation-in-page__status_wrapper .js-m-navigation-in-page__item-indicator-init',
			targetWrapperSelector: '.js-m-navigation-in-page__wrapper',
			pageTitleSelector: '.js-m-navigation-in-page__page-title',
			stickyCtaSelector: '.js-m-navigation-in-page__cta',
			stickyShareBtn: '.js-m-navigation-in-page__share-btn',
			stickyShareSelector: '.js-m-navigation-in-page__share-container',
			sharePopupView: 'm-navigation-in-page__share-popup-view',
			shareShowPopup: 'state-m-navigation-in-page__share-popup-shown',
			active: 'state-m-navigation-in-page__item-anchor--is-active',
			fadeInBar: 'state-m-navigation-in-page__fade--in',
			fadeOutBar: 'state-m-navigation-in-page__fade--out',
			titleFlexEnd: 'state-m-navigation-in-page__cta-wrapper--flex-end',
			scrollDirection: 0,
			lastScrollTop: 0,
			threshold: 0,
			thresholdOffset: 200,
			anchorBarButtons: [] as any,
			targetNavElements: $() as JQuery,
			anchorBarBreakpoints: [] as any,
		};
		this.$ctx = $(this._ctx);

		this.initInpage(true);
		$(window).on('resize.NavigationInPage', this.initInpage.bind(this));
		$(window).on('NavigationInPage:reInit', () => this.initInpage(true));
		$(window).on('NavigationInPage:reInitNoClick', () => this.initInpage(false));
		$(window).on('hashchange', () => this.initInpage(true));

		this.initPageTitle();
		this.initStickyCta();
		this.initStickyShare();

		resolve();
	}

	initInpage(triggerHash: boolean) {
		this.listItemPlaceholder = this.getListItemPlaceholder();
		if (
			this.shouldInpageNavgationBeShown() ||
			$('.js-sticky-cta').length !== 0 ||
			$('.js-sticky-buttons').length !== 0
		) {
			const hasHash = this.pageHasHashTag();

			this.activeItem = -1;
			this.winScrollY = window.pageYOffset;

			this.regScrollEvent();

			this.setListItems(
				this.config.attributeNameTarget,
				this.createArrayData(this.config.attributeNameId, true),
				this.createArrayData(this.config.attributeNameTitle, false)
			);

			this.config.anchorBarButtons = <any>(
				this._ctx.querySelectorAll(this.config.targetSelector + ' ' + this.config.buttonSelector)
			);
			this.regAnchorBarButtonsEvt();
			this.setMobileAction();

			if (hasHash === true && triggerHash === true) {
				const normalizedHash = window.location.hash.substr(1).toLowerCase(); // Convert hash to lowercase
				const elemWithHash = $(`[${this.config.attributeNameTarget}="${normalizedHash}"]`);

				window.onload = function () {
					var hash = window.location.hash;
					console.log(hash);
					handleJump(hash);
				};
				$(elemWithHash).on('click', (event: Event) => {
					event.preventDefault(); // Prevent default anchor behavior
				});
			}
		} else {
			if ($('.js-sticky-cta').length === 0 && $('.js-sticky-buttons').length === 0) {
				this.removeInpageNavigation();
			}
		}
		// Function to handle the jump action
		function handleJump(targetValue: any) {
			targetValue = replaceSpecialCharactersMain(targetValue);
			targetValue = targetValue ? targetValue.toLowerCase() : targetValue;
			let targetElement = document.querySelector(`div[data-anchor-id="${targetValue.slice(1).toLowerCase()}"]`);
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' });
				console.log('Anchor ID targetElement::', targetElement); // Log the anchor element
			}
		}

		function replaceSpecialCharactersMain(input: string) {
			const replacements: Record<string, string> = {
				"ä": "ae",
				"ö": "oe",
				"ü": "ue",
				"ß": "ss",
				" ": "",
				"&": "",
				"-": "",
				"+": ""
			};

			return input.replace(/[äöüß &+-]/g, (char: string) => replacements[char] || "");
		}
	}

	stop() { }

	/**
	 * Sticky Title
	 */
	initPageTitle() {
		const docTitle = document.title;
		if (docTitle.indexOf('|') != -1) {
			const title = docTitle.split('|');
			$(this.config.pageTitleSelector).text(title[0]);
		} else {
			$(this.config.pageTitleSelector).text(docTitle);
		}
	}
	/**
	 * Sticky Cta
	 */
	initStickyCta() {
		const formID = '#' + $('.m-teaser-contact-form').attr('data-anchor-id');
		if ($('.js-sticky-cta').length > 0) {
			const stickyCta = $('.js-sticky-cta').eq(0);
			const stickyCtaTheme = stickyCta.parent().attr('data-theme');
			$(this.config.stickyCtaSelector).text(stickyCta.text());
			$(this.config.stickyCtaSelector).attr('href', stickyCta.attr('href'));
			$(this.config.stickyCtaSelector).attr('target', stickyCta.attr('target'));
			$(this.config.stickyCtaSelector).attr('data-mktoflow-id', stickyCta.data('mktoflow-id'));
			$(this.config.stickyCtaSelector).attr('data-formflow-id', stickyCta.data('formflow-id'));
			$(this.config.stickyCtaSelector).addClass('a-button--' + stickyCtaTheme);
			// Scroll
			if ($('.js-m-stage-product__button').length > 0) {
				initHashScrolling();
				addScrollClickTrigger($(this.config.stickyCtaSelector));
			} else if (stickyCta.attr('href') !== formID) {
				const url = stickyCta.attr('href');
				const idx = url.indexOf('#');
				if (idx === 0) {
					initHashScrolling();
					addScrollClickTrigger($(this.config.stickyCtaSelector));
				} else {
					// if the <a> is not an anchor, just do the <a>'s original behavior
				}
			}
		} else if ($('.js-sticky-buttons').length > 0) {
			const stickyCtaGroup = $('.js-sticky-buttons');
			const stickyCtaTheme = stickyCtaGroup.attr('data-theme');
			$(this.config.stickyCtaSelector).addClass('a-button--' + stickyCtaTheme);
			if (stickyCtaGroup.children().length == 1) {
				const stickyCta = stickyCtaGroup.children();
				$(this.config.stickyCtaSelector).text(stickyCta.text());
				$(this.config.stickyCtaSelector).attr('href', stickyCta.attr('href'));
				$(this.config.stickyCtaSelector).attr('target', stickyCta.attr('target'));
			} else {
				const stickyCtaText = stickyCtaGroup.attr('data-title');
				$(this.config.stickyCtaSelector).text(stickyCtaText);
				$(this.config.stickyCtaSelector).addClass('m-navigation-in-page__cta-toggle');
				$(this.config.stickyCtaSelector)
					.next()
					.append($('.js-sticky-buttons').html());
				$(this.config.stickyCtaSelector).on('click', (ev: any) => {
					ev.stopPropagation();
					$(ev.currentTarget)
						.parent()
						.toggleClass('is-expanded');
				});
				$('body').on('click', () => {
					$(this.config.stickyCtaSelector)
						.parent()
						.removeClass('is-expanded');
				});
			}
		} else {
			$(this.config.stickyCtaSelector)
				.parent()
				.parent()
				.addClass(this.config.titleFlexEnd);
			$(this.config.stickyCtaSelector)
				.parent()
				.remove();
		}
	}

	/**
	 * Sticky Share
	 */
	initStickyShare() {
		const shareLocation = $('.m-page-share-container');
		const shareSelector = $('.m-page-share');
		if (shareLocation.length > 0) {
			shareLocation.after("<div class='m-page-share-container--placeholder'></div>");
			$(this.config.stickyShareSelector).append(shareSelector.clone());
			if ($('.o-header__sticky-bar--hide-navigation').length > 0) {
				this.stickyPopupShareShow();
			} else {
				this.stickyPopupShare();
			}
		} else {
			$(this.config.stickyShareSelector).hide();
		}
	}

	setClipboardAnchorBtn() {
		$(this.config.stickyShareSelector).on('click', '.m-page-share__anchor--hyperlink', () => {
			this.copyURLToClipboard();
		});
	}

	stickyPopupShare() {
		$(this.config.stickyShareSelector).addClass(this.config.sharePopupView);
		this.stickyPopupShareShow();
	}
	stickyPopupShareShow() {
		$(this.config.stickyShareBtn).on('click', (e: Event) => {
			e.stopPropagation();
			$(this.config.stickyShareSelector).toggleClass(this.config.shareShowPopup);
		});
		$(window).on('scroll', () => {
			$(this.config.stickyShareSelector).removeClass(this.config.shareShowPopup);
		});
		$(this.config.stickyShareSelector).on('click', (e: Event) => {
			e.stopPropagation();
		});
		$('body').on('click', () => {
			$(this.config.stickyShareSelector).removeClass(this.config.shareShowPopup);
		});
	}

	/* ####### SECTION - SET DATA MODEL */

	/**
	 *
	 */

	setMobileAction() {
		setTimeout(() => {
			this.hasCanvasOffset = this.hasAnchorBarOffCanvas();
		}, 1);
	}

	/**
	 * Returns a boolean value to indicate if a Inpage Navigation should be shown
	 * @returns {boolean}
	 */
	shouldInpageNavgationBeShown() {
		const inpageNavElements = $('[' + this.config.attributeNameId + ']');
		return inpageNavElements.length > 0;
	}

	/**
	 * Remove the Inpage Navigation from the DOM. Always when no AnchorIds and AnchorTitles are available
	 */
	removeInpageNavigation(): void {
		$(this.config.mainSelector).remove();
	}

	/**
	 * Returns the placeholder from the mark up
	 * @return {string} - Returns the placeholder item from the mark up
	 */
	getListItemPlaceholder(): string {
		return this.$ctx.find(this.config.targetSelector).html();
	}

	/**
	 * Sets the target elements of the inpage navigation
	 * @param createTargetNavElements - boolean indicator to avoid redundant creation of target navigation elements
	 * @param inpageNavElements - Array of all navigation inpage elements
	 */
	setTargetData(createTargetNavElements: boolean, inpageNavElements: JQuery) {
		if (createTargetNavElements && inpageNavElements.length !== 0) {
			this.config.targetNavElements = inpageNavElements;
			this.config.threshold = this.config.targetNavElements[0].offsetTop - this.config.thresholdOffset;
			this.config.anchorBarBreakpoints = this.setAnchorBarBreakpoints();
		}
	}

	/* ####### SECTION - SECTION - RENDERING MARK UP */

	/**
	 * Set HTML mark-up of generated list items
	 * @param anchorAttributeName - Holds the attribute name of the anchor element
	 * @param targetAnchorIds - Holds the anchor IDs of the targets
	 * @param targetAnchorTitles - Holds the titles of the inpage navigation elements
	 */
	setListItems(anchorAttributeName: string, targetAnchorIds: any[], targetAnchorTitles: any[]) {
		const $el = this.$ctx.find(this.config.targetSelector);
		let listItems = '';

		targetAnchorIds.forEach((id) => {
			const title = this.gettargetAnchorTitlesId(id);

			if (title) {
				listItems += this.createListItem(anchorAttributeName, id, title);

				this.removeTitleFromList(targetAnchorTitles, title);
			}
		});

		$el.html(listItems);
		this.$links = this.$ctx.find('[' + this.config.attributeNameTarget + ']');
	}


	gettargetAnchorTitlesId(id: any) {
		if (id.startsWith('vc_') || id.startsWith('video')) {
			return 'Video';
		}
		switch (id) {
			case 'brochuresdownloads':
				return 'Brochures & Downloads';
			case 'relatedbrandsproducts':
			case 'relatedbrandsandproducts':
				return 'Related brands and products';
			case 'relatedtopics':
				return 'Related topics';
			case 'featuredbrands':
				return 'Featured Brands';
			case 'featuredproducts':
				return 'Featured Products';
			default:
				return undefined;
		}
	}

	removeTitleFromList(targetAnchorTitles: any, title: any) {
		const titleIndex = targetAnchorTitles.findIndex((t: any) => t === title);
		if (titleIndex !== -1) {
			targetAnchorTitles.splice(titleIndex, 1);
		}
	}

	/**
	 * Creates an array of the given attribute values
	 * @param targetAttribute - Holds the attribute name of target elements
	 * @param navElements - Holds a boolean value for transmitting it into the setTargetData function
	 * @return array - Returns the created data as an array
	 */
	createArrayData(targetAttribute: string, navElements: boolean): string[] {
		const inpageNavElements: JQuery = $('[' + targetAttribute + ']');
		const attributeList = [] as string[];

		inpageNavElements.each((index: number, el: HTMLElement) => {
			const targetAttributeValue: string = $(el).attr(targetAttribute);
			attributeList.push(targetAttributeValue);
		});

		this.setTargetData(navElements, inpageNavElements);
		return attributeList;
	}

	/**
	 * Create one list item (anchor) of the inpage navigation from the given placeholder of the mark up
	 * @param anchorAttributeName - Holds the attribute name of the anchor element
	 * @param anchorAttributeNameId - Holds the anchor IDs of the targets
	 * @param anchorTitle - Holds the titles of the inpage navigation elements
	 * @return {string} - Returns the final mark up that was generated with the placeholder mark up
	 */
	createListItem(anchorAttributeName: string, anchorAttributeNameId: string, anchorTitle: string): string {
		const $listItem = $(this.listItemPlaceholder);

		$listItem.find(this.config.buttonSelector).attr(anchorAttributeName, anchorAttributeNameId);
		$listItem.find(this.config.buttonSelector).attr('href', '#' + anchorAttributeNameId);
		$listItem.find(this.config.buttonSelector).text(anchorTitle);

		return $listItem.prop('outerHTML');
	}

	/**
	 * Get all offsetTop values of the relevant target elements and save them as an array containing the breakpoints
	 * @return array - Returns an array of the corresponding breakpoints
	 */
	setAnchorBarBreakpoints(): number[] {
		const breakpoints: number[] = [];

		this.config.targetNavElements.each((index, item) => {
			breakpoints[index] = item.offsetTop - this.config.thresholdOffset;
		});

		breakpoints.push(document.body.offsetHeight);

		return breakpoints;
	}

	/** ###### SECTION - SCROLLING & INTERACTIONS */

	/**
	 * Register document scroll event which decides when to show or hide the inpage navigation
	 */
	regScrollEvent(): void {
		$(window)
			.off('scroll.NavigationInPage')
			.on('scroll.NavigationInPage', this.onScroll.bind(this));
		this.onScroll();
	}

	onScroll() {
		if (this.animationFrameId > 0) {
			window.cancelAnimationFrame(this.animationFrameId);
		}
		this.animationFrameId = window.requestAnimationFrame(() => {
			this.animationFrameId = 0;
			this.handleScrolling();
		});
	}

	showCtaThreshold() {
		const shareLocation = $('.m-page-share-container').last();
		const ctaSelector = $('.js-sticky-cta');
		if (shareLocation.length > 0) {
			const shareOffsetTop = shareLocation.offset().top;

			if (shareOffsetTop > 0) {
				this.config.threshold = shareOffsetTop + shareLocation.height();
			}
		} else if (ctaSelector.length > 0) {
			const ctaOffsetTop = ctaSelector.offset().top;

			if (ctaOffsetTop > 0) {
				this.config.threshold = ctaOffsetTop + ctaSelector.height();
			}
		}
	}

	handleScrolling() {
		this.hasCanvasOffset = this.hasAnchorBarOffCanvas();
		this.winScrollY = window.pageYOffset;
		this.setScrollDirection();
		this.calcAndSetAnchorItemActive();
		this.showCtaThreshold();
		this.winScrollY > this.config.threshold ? this.showHideAnchorBar(true) : this.showHideAnchorBar(false);
	}

	/**
	 * Move the inpage navigation vertically and calls the same function that is also used in the on
	 * click handler of the anchor bar buttons
	 *
	 * @param {number} idx
	 */
	moveAxisX(idx: number) {
		if (this.hasCanvasOffset && idx >= 0) {
			if (this.activeItem !== idx && this.activeItem >= 0) {
				this.actAnchorBarButtonEvt(false, idx);
				//this.progressBarSetWidth(idx);
			}
		}
	}

	/**
	 * Shows or hides the inpage navigation by the given boolean parameter
	 * @param  showAnchorBar - Boolean value to indicate the anchor bar to be shown
	 */
	showHideAnchorBar(showAnchorBar: boolean) {
		const $target: any = this.$ctx.find(this.config.targetWrapperSelector);
		clearTimeout(this.timer);
		showAnchorBar ? this.showAnchorBar($target) : this.hideAnchorBar($target);
	}

	/**
	 * Show the inpage navigation
	 * @param  $target - Holds the target element to make actions on
	 */
	showAnchorBar($target: any) {
		$target.css({
			display: 'flex',
		});
		$target.removeClass(this.config.fadeOutBar);
		$target.addClass(this.config.fadeInBar);

		this.setClipboardAnchorBtn();
	}

	/**
	 * Hide the inpage navigation
	 * @param  $target - Holds the target element to make actions on
	 */
	hideAnchorBar($target: any) {
		$target.removeClass(this.config.fadeInBar);
		$target.addClass(this.config.fadeOutBar);
		this.activeItem = -1;
		this.timer = setTimeout(() => {
			$target.hide();
		}, 500);
	}

	/**
	 * Sets the direction which was scrolled
	 */
	setScrollDirection() {
		const currentYScroll = this.winScrollY;
		currentYScroll > this.config.lastScrollTop
			? (this.config.scrollDirection = 1)
			: (this.config.scrollDirection = -1);
		this.config.lastScrollTop = currentYScroll;
	}

	/**
	 * Calculates and set the highlighted anchor item. (If the current scroll Y - axis demands a highlighting of its element in the inpage navigation bar)
	 */
	calcAndSetAnchorItemActive() {
		this.config.anchorBarBreakpoints.forEach((topPos, index) => {
			if (this.winScrollY >= topPos) {
				// Page is scrolled at the bottom, so it activates the last anchor bar item
				if ($(window).scrollTop() + window.innerHeight >= $(document).height()) {
					// Add increment to indicate that the page is scrolled down at the bottom of the page
					index = this.config.anchorBarButtons.length - 1;
				}

				// Substract the increment of +1 from above top avoid DOM reference failures,
				// after once scrolled to the bottom of the page
				if (this.config.anchorBarButtons.length === index) {
					index = index - 1;
				}

				if (this.winScrollY <= this.config.anchorBarBreakpoints[index + 1]) {
					//this.progressBarSetWidth(index);
					this.moveAxisX(index);
					this.activeItem = index;
					this.$links.removeClass(this.config.active);
					this.$links.eq(index).addClass(this.config.active);
				} else if (this.activeItem === index) {
					this.$links.eq(index).removeClass(this.config.active);
				}
			} else {
				this.$links.eq(index).removeClass(this.config.active);
			}
		});
	}

	/**
	 * Set the display property of the status bars' wrapper element to 'block' to enable this.progressBarCalcWidth()
	 * returning the proper calculation value rather than returning 0
	 * @param index - Holds the index of the element to be highlighted
	 */
	progressBarSetWidth(index: number) {
		this.$ctx.find(this.config.statusBarWrapperSelector).css({
			display: 'block',
		});

		this.$ctx.find(this.config.statusBarSelector).css({
			width: this.progressBarCalcWidth(index) + 'px',
		});
	}

	/**
	 * Calculates the width of the inpage navigation status bar
	 * @param index - Holds the index of the highlighted element
	 */
	progressBarCalcWidth(index: number): number {
		return (
			this.config.anchorBarButtons[index].offsetLeft +
			this.config.anchorBarButtons[index].offsetWidth -
			this._ctx.querySelector(this.config.targetSelector).scrollLeft
		);
	}

	/**
	 * Register click event for inpage navigation items
	 */
	regAnchorBarButtonsEvt() {
		$(this.config.anchorBarButtons)
			.off('click.NavigationInPage')
			.on('click.NavigationInPage', (ev: Event) => {
				ev.preventDefault();
				const dataAttrOfClickedElem = $(ev.currentTarget).data('anchor-id-target');
				const formID = $('.m-teaser-contact-form').attr('data-anchor-id');
				if (dataAttrOfClickedElem !== formID) {
					this.actAnchorBarButtonEvt(true, undefined, ev.currentTarget as HTMLElement);
				}
				this.historyPush(dataAttrOfClickedElem);
			});
	}

	/**
	 * Returns the width of the inpage navigation bar
	 * @returns width - Returns the width of all elements of the navigation inpage anchor bar
	 */
	getWidthOfAnchorBar(): number {
		let width = 0;
		for (let i = 0; this.config.anchorBarButtons.length > i; i++) {
			width += this.config.anchorBarButtons[i].offsetWidth + 40;
		}

		return width;
	}

	/**
	 * Returns a boolean value that indicates that the inpage navigation items have more width as the document width
	 */
	hasAnchorBarOffCanvas(): boolean {
		return this.getWidthOfAnchorBar() > document.body.offsetWidth;
	}

	/**
	 * Action for the click event of each inpage navigation item
	 * @param scrollTo
	 * @param idx - Holds the index of the element to be make an action for
	 * @param elem - trigger element
	 */
	actAnchorBarButtonEvt(scrollTo: boolean, idx?: number, elem?: HTMLElement) {
		const gradientSpacing = 20;
		const offset = 50;
		if (elem) {
			idx = $(this.config.anchorBarButtons).index(elem);
		}
		const anchorBarOffsetLeft: number = this.config.anchorBarButtons[idx].offsetLeft - gradientSpacing - offset;

		this.$ctx
			.find(this.config.targetSelector)
			.stop(true, true)
			.animate(
				{
					scrollLeft: anchorBarOffsetLeft,
				},
				150,
				() => {
					if (scrollTo) {
						scrollToElement($(this.getAnchorElement(idx)), true, this.calcOffsetY());
					}
				}
			);
	}

	/**
	 * Returns the inpage navigation anchor element by the given index
	 * @param idx - Holds the index of the element to target to
	 * @returns - A jQuery object from the anchor element
	 */
	getAnchorElement(idx: number): object {
		const obj: any = this.config.targetNavElements[idx];
		const elAttribute: any = obj.getAttributeNode(this.config.attributeNameId).value;
		return $('[' + this.config.attributeNameId + '="' + elAttribute + '"]');
	}

	/**
	 * Calculates the top offset of the parent element of this component
	 */
	calcOffsetY(): number {
		return $(this.config.targetWrapperSelector).height() + 20;
	}

	historyPush(hash: string): any {
		if (history.pushState) {
			const newurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname +
				window.location.search +
				'#' +
				hash;
			window.history.pushState({ path: newurl }, '', newurl);
		}
	}

	replaceSpecialCharacters(input: string): string {
		const replacements: Record<string, string> = {
			"ä": "ae",
			"ö": "oe",
			"ü": "ue",
			"ß": "ss",
			" ": "",
			"&": "",
			"-": "",
			"+": ""
		};

		return input.replace(/[äöüß &+-]/g, (char: string) => replacements[char] || "");
	}

	pageHasHashTag(): boolean {
		let result = this.replaceSpecialCharacters(window.location.hash.substr(1));
		result = result ? result.toLowerCase() : result;
		if (window.location.hash && $(`[${this.config.attributeNameId}="${result}"]`).length > 0) {
			return true;
		}
		return false;
	}

	/**
	 * Copies the URL (location.href) into the browser clipboard
	 * @constructor {function}
	 * @returns {void}
	 */
	copyURLToClipboard(): void {
		const opts: any = this.getClipboardOpts();
		const data = this.getLocationHref();

		this.showDebugInfo(opts, data);
		this.showFeedbackMsg();
		copy(data, opts);
		this.hideFeedbackMsgTimer();
	}

	/**
	 * getClipboardOpts
	 * @constructor {function} getClipboardOpts
	 * @returns {Object} any
	 */
	getClipboardOpts(): any {
		return {
			debug: false,
			message: 'Press #{⌘+C} on macOS or #{Ctrl+C} on Windows to copy',
		};
	}

	/**
	 * getLocationHref
	 * @constructor {function} getLocationHref
	 * @returns {string} string
	 */
	getLocationHref(): string {
		return document.location.href;
	}

	/**
	 * showDebugInfo - Description
	 * @constructor {function} showDebugInfo
	 * @param {Object} opts holds thze options for the clipboard object
	 * @param {string} data holds the data to be copied into the clipboard
	 */
	showDebugInfo(opts: any, data: string) {
		if (opts.debug) {
			// eslint-disable-next-line no-console
			console.log('Copied to clipboard: ', data);
		}
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	showFeedbackMsg() {
		$(this.config.stickyShareSelector)
			.find('.m-page-share__copy-msg')
			.removeClass('show');
		$(this.config.stickyShareSelector)
			.find('.m-page-share__copy-msg')
			.addClass('show');
	}

	/**
	 * hideFeedbackMsg
	 * @constructor {function} hideFeedbackMsg
	 */
	hideFeedbackMsg() {
		$(this.config.stickyShareSelector)
			.find('.m-page-share__copy-msg')
			.removeClass('show');
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	hideFeedbackMsgTimer() {
		window.setTimeout(() => {
			this.hideFeedbackMsg();
		}, 3500);
	}
}
